import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { YourProductApplication } from '../../model/ngrx/your-product-application.model';

export const ADD_YOUR_PRODUCT_APPLICATION = '[YOURPRODUCTAPPLICATION] Add';
export const REMOVE_YOUR_PPRODUCT_APPLICATION = '[YOURPRODUCTAPPLICATION] Remove';

// AddPersonalDetails
export class AddYourProductApplication implements Action {
    readonly type = ADD_YOUR_PRODUCT_APPLICATION;

    constructor(public payload: YourProductApplication) { }
}
// RemovePersonalDetails
export class RemoveYourProductApplication implements Action {
    readonly type = REMOVE_YOUR_PPRODUCT_APPLICATION;

    constructor(public payload: number) { }
}

export type Actions = AddYourProductApplication | RemoveYourProductApplication;
